<template>
  <div>
    <nav class="navbar fixed-top navbar-light w-100"
      v-bind:class="viewer? 'navbar-grey' : 'navbar-blue'">
      <div class="container-fluid w-100">
        <div class="row w-100">
          <div class="col-3 pr-0 col-md-2">
            <div class="row">
              <div class="col-4 col-sm-3 col-md-3 col-lg-2 col-xxl-2 text-right">
                <img src="/img/BH_logo.svg" class="bh-logo">
              </div>
              <div class="col-4 col-sm-3 col-md-3 col-lg-3 col-xxl-2 text-center">
                <label class="title">Bowhead Health</label>
              </div>
            </div>
          </div>
          <div v-if="viewer" class="col-9 col-md-9 text-center">
            <label class="d-sm-none page">{{ $t("general.page", {pageNum: pageNum, pages: pages})}}</label>
            <div class="d-none d-sm-block pt-2">
            <label class="d-inline page">{{ $t("general.page", {pageNum: pageNum, pages: pages})}}</label>
            <div v-if="!isMobile" class="vl d-inline"></div>
            <div v-if="!isMobile" class="d-inline white" @click="less">
              <span v-show="zoom >=2">-</span>
            </div>
            <div v-if="!isMobile" class="d-inline">
              <span class="percen">
                <input v-model="zoom"
                  class="percentaje"
                  type="number"
                  min="1"
                  max="200">
              </span>
            </div>
            <div v-if="!isMobile" class="d-inline white" @click="plus">
              <span v-show="zoom <=199">+</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="pt-5">
      <fade-transition :duration="200" origin="center top" mode="out-in">
        <router-view />
      </fade-transition>
    </div>
  </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions'

export default {
  components: {
    FadeTransition
  },
  data () {
    return {
      zoom: 100
    }
  },
  computed: {
    viewer () {
      return this.$store.getters.getViewer
    },
    pages () {
      return this.$store.getters.getPages
    },
    pageNum () {
      return this.$store.getters.getPageNum
    },
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    less () {
      this.zoom--
    },
    plus () {
      this.zoom++
    }
  },
  watch: {
    zoom (val) {
      if (val <= 0 || val > 200) {
        this.zoom = 100
        this.$store.commit('SET_PERCENTAGE', 100)
      } else {
        this.$store.commit('SET_PERCENTAGE', val)
      }
    }
  }
}
</script>

<style>
.navbar-blue {
  background-color: #21ccdd !important;
}

.navbar-grey {
  background-color: #555565 !important;
}

.bh-logo {
  width: 2.5rem;
  height: 2.5rem;
}

.title {
  color: #fff;
  padding-left: 1rem;
  font-weight: 900;
  font-size: .95rem;
  line-height: 1;
  margin-top: .5rem;
  max-width: 3rem;
}

.page {
  color: #fff;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1;
  margin-top: .85rem;
}

.vl {
  margin: 6px;
  border-left: 1px solid #fff;
  height: 1.1rem;
}

.percentaje {
  width: 3rem;
  height: 27px;
  border: none;
  font-size: 13px;
  text-align: center;
  font-weight: 300;
  outline: none;
  background: #40404D 0% 0% no-repeat padding-box;
  color: #fff;
  padding-right:15px;
}

.percen {
  position: relative;
}
.percen:after {
  content: '%';
  position: absolute;
  top: 0;
  right: 5px;
  color: #fff;
  font-weight: 300;
}

.white {
  margin: 3px;
  color: #fff;
  cursor: pointer;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
